import type { Socket } from 'socket.io-client';
import { Annotation } from 'src/models/annotation';
import { Controller } from 'src/models/controller';
import { Firmware, FirmwareSearchResult } from 'src/models/firmware';
import { JobLog, LogSearchResult } from 'src/models/jobLog';
import { Organization } from 'src/models/organization';
import { User } from 'src/models/user';
import { Bundle, BundleSearchResult } from '../../models/bundle';

export interface DqSocketRequestOptions {
  /** An abort signal that allows the request to be aborted. */
  signal?: AbortSignal;
}

export interface DqSocketContextData {
  socket: typeof Socket | null;
  request: <R extends any>(event: string, data: any, options?: DqSocketRequestOptions) => Promise<R>;
  connected: boolean;
}

export type InferSocketResponseMap = {
  controllers: Controller;
  firmware: Firmware;
  organizations: Organization;
  logs: JobLog;
  users: User;
  annotations: Annotation;
  bundles: Bundle;
};

export type InferSearchResponseMap = {
  logs: LogSearchResult;
  firmware: FirmwareSearchResult;
  bundles: BundleSearchResult;
  // NOTE: These socket searches are not implemented yet.
  controllers: any;
  organizations: any;
  users: any;
  annotations: any;
};

// Is this coupling the two unnecessarily?
export type SentinelKey = keyof InferSocketResponseMap & keyof InferSearchResponseMap;

export type InferSocketResponse<K extends SentinelKey> = InferSocketResponseMap[K];
export type InferSocketSearchResponse<K extends SentinelKey> = InferSearchResponseMap[K];

export enum SentinelQueryEvaluation {
  Include = 'include',
  Exclude = 'exclude',
  Indeterminate = 'indeterminate',
}
export type SentinelQueryEvaluator<K extends SentinelKey> = (
  data: InferSocketResponse<K>,
  query: any,
) => SentinelQueryEvaluation;
